import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout, Button } from 'antd';
import { UserOutlined, HomeOutlined, DashboardOutlined, BookOutlined } from '@ant-design/icons';
import axios from 'axios';

const { Header } = Layout;

const isLoggedIn = () => {
  return !!localStorage.getItem('access_token');
};

const NavBar = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const access_token = localStorage.getItem('access_token');
      const refresh_token = localStorage.getItem('refresh_token');

      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/logout/`,
        { refresh_token },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );

      // Remove tokens from localStorage
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      navigate('/login');
    } catch (err) {
      console.error('Logout failed', err);
      alert('Logout failed!');
    }
  };

  return (
    <Header
      style={{
        backgroundColor: '#f0f0f0',
        padding: '0 20px',
        borderBottom: '3px solid',
        borderImage: 'linear-gradient(135deg, #1890ff 0%, #722ed1 100%) 1',
        position: 'fixed',       // Fixed position
        top: 0,                  // Aligns at the top of the viewport
        width: '100%',           // Full width for consistency
        zIndex: 1000,            // Ensures it stays on top
      }}
    >
      {/* Container for Navbar */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {/* Left side: Home and Dashboard */}
        <div style={{ display: 'flex', gap: '20px' }}>
          <Button
            type="text"
            icon={<HomeOutlined />}
            style={{ fontSize: '16px' }}
            onClick={() => navigate('/')}
          >
            Home
          </Button>
          <Button
            type="text"
            icon={<BookOutlined />}
            style={{ fontSize: '16px' }}
            onClick={() => navigate('/glossary')}
          >
            Glossary
          </Button>
          <Button
            type="text"
            icon={<DashboardOutlined />}
            style={{ fontSize: '16px' }}
            onClick={() => navigate('/dashboard')}
          >
            Dashboard
          </Button>
        </div>

        {/* Right side: Login/Logout */}
        <div>
          {isLoggedIn() ? (
            <Button
              type="text"
              icon={<UserOutlined />}
              onClick={handleLogout}
              style={{ color: 'black', fontSize: '16px' }}
            >
              Logout
            </Button>
          ) : (
            <Button
              type="text"
              icon={<UserOutlined />}
              style={{ color: 'black', fontSize: '16px' }}
              onClick={() => navigate('/login')}
            >
              Login
            </Button>
          )}
        </div>
      </div>
    </Header>
  );
};

export default NavBar;
